// #region imports

// --- Angular
import { Component, Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  @Input() text: string = '';
}
